

export default ({refetch}) => async (params) => {

    const { queryNames, partialVariables } = params

    await refetch({ queryNames, partialVariables })
    
}